import { useState } from 'react';
import AdminAccordionSection from './AdminAccordionSection';
import HelpDocumentsSection from './HelpDocumentsSection';
//import UserRoleAssignmentSection from './UserRoleAssignmentSection';
import SubmissionLevelControlsSection from './SubmissionLevelControlsSection';
import './AdminConsole.scss';

const AdminConsoleComponent = (props:any) => {
  const [openSections, setOpenSections] = useState<string[]>([
    'helpDocuments',
    'userRoleAssignment',
    'submissionLevelControls'
  ]);

  const toggleSection = (key: string) => {
    setOpenSections((previous) =>
      previous.includes(key) ? previous.filter((item) => item !== key) : [...previous, key]
    );
  };

  const isSectionOpen = (key: string) => openSections.includes(key);

  return (
    <div className='admin-console'>
      <AdminAccordionSection
        title='Help Documents'
        isOpen={isSectionOpen('helpDocuments')}
        onToggle={() => toggleSection('helpDocuments')}
      >
        <HelpDocumentsSection />
      </AdminAccordionSection>

      {/* <AdminAccordionSection
        title='User Role Assignment'
        isOpen={isSectionOpen('userRoleAssignment')}
        onToggle={() => toggleSection('userRoleAssignment')}
      >
        <UserRoleAssignmentSection />
      </AdminAccordionSection> */}

      <AdminAccordionSection
        title='Submission-Level Controls'
        isOpen={isSectionOpen('submissionLevelControls')}
        onToggle={() => toggleSection('submissionLevelControls')}
      >
        <SubmissionLevelControlsSection  {...props}/>
      </AdminAccordionSection>
    </div>
  );
};

export default AdminConsoleComponent;
